import ClassNames from 'classnames'
import React from 'react'
import {
  CmsLayoutBase
} from './../../base'
import { CmsLayoutWrapper } from './styled'

class CmsLayoutTopbar extends React.PureComponent {
  render() {
    return (
      <CmsLayoutBase.Topbar
        {...this.props}
      />
    )
  }

  static defaultProps = {
  }
}

class CmsLayoutSidebar extends React.PureComponent {
  render() {
    return (
      <CmsLayoutBase.Sidebar
        {...this.props}
      />
    )
  }

  static defaultProps = {
  }
}

class CmsLayoutContent extends React.PureComponent {
  render() {
    return (
      <CmsLayoutBase.Content
        {...this.props}
      />
    )
  }

  static defaultProps = {
  }
}

export class CmsLayout extends React.PureComponent {
  render() {
    const {
      children,
      className
    } = this.props

    // props for css classes
    const classes = ClassNames(
      className,
    )

    return (
      <CmsLayoutWrapper
        {...this.props}
        className={classes}
      >
        {children}
      </CmsLayoutWrapper>
    )
  }

  static Topbar = CmsLayoutTopbar
  static Sidebar = CmsLayoutSidebar
  static Content = CmsLayoutContent

  static defaultProps = {
  }

  static propTypes = {
    // TYPE > node, string, number, bool, array, object, symbol, func
  }
}
